import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function BonusSection() {
  return <section className="py-14 bg-zinc-950 relative border-t border-zinc-900" data-id="element-26">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-27">
        <FadeIn data-id="element-28">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-10 text-center" data-id="element-29">
            LOS 2 BONOS INCLUIDOS
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-30">
          {/* BONO 1 */}
          <FadeIn delay={0.1} direction="up" className="h-full" data-id="element-31">
            <div className="bg-zinc-900/80 border border-green-500/30 rounded-2xl p-8 h-full relative overflow-hidden shadow-[0_0_30px_rgba(34,197,94,0.05)]" data-id="element-32">
              <div className="absolute top-0 right-0 w-40 h-40 bg-green-500/10 rounded-full pointer-events-none" style={{
              filter: 'blur(30px)'
            }} data-id="element-33"></div>

              <div className="relative z-10" data-id="element-34">
                <div className="inline-block px-4 py-1.5 bg-green-500/10 border border-green-500/20 rounded-full text-green-400 font-bold text-sm tracking-wide mb-6" data-id="element-35">
                  🟢 BONO 1
                </div>

                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-36">
                  Kit Rescate en la Calle
                </h3>
                <p className="text-green-400 font-medium mb-6" data-id="element-37">
                  Protocolo de 5 Minutos para Volver a Moverte
                </p>

                <p className="text-zinc-300 mb-6 font-medium" data-id="element-38">
                  En menos de 5 minutos sabés exactamente qué hacer cuando algo
                  falla lejos de casa. Sin herramientas. Sin pánico. Sin
                  depender de nadie.
                </p>

                <ul className="space-y-4 text-zinc-400" data-id="element-39">
                  <li className="flex items-start gap-3" data-id="element-40">
                    <span className="text-green-500 mt-1" data-id="element-41">✓</span>
                    <span data-id="element-42">
                      Incluye el árbol de decisión express de 60 segundos para
                      cualquier falla.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-43">
                    <span className="text-green-500 mt-1" data-id="element-44">✓</span>
                    <span data-id="element-45">El protocolo 5-Min Reset universal.</span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-46">
                    <span className="text-green-500 mt-1" data-id="element-47">✓</span>
                    <span data-id="element-48">
                      La tabla completa de síntomas y acciones inmediatas.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-49">
                    <span className="text-green-500 mt-1" data-id="element-50">✓</span>
                    <span data-id="element-51">
                      La tarjeta de emergencia imprimible para llevar siempre en
                      la mochila.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>

          {/* BONO 2 */}
          <FadeIn delay={0.2} direction="up" className="h-full" data-id="element-52">
            <div className="bg-zinc-900/80 border border-blue-500/30 rounded-2xl p-8 h-full relative overflow-hidden shadow-[0_0_30px_rgba(59,130,246,0.05)]" data-id="element-53">
              <div className="absolute top-0 right-0 w-40 h-40 bg-blue-500/10 rounded-full pointer-events-none" style={{
              filter: 'blur(30px)'
            }} data-id="element-54"></div>

              <div className="relative z-10" data-id="element-55">
                <div className="inline-block px-4 py-1.5 bg-blue-500/10 border border-blue-500/20 rounded-full text-blue-400 font-bold text-sm tracking-wide mb-6" data-id="element-56">
                  🔵 BONO 2
                </div>

                <h3 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-57">
                  Herramientas Cero + Setup Perfecto
                </h3>
                <p className="text-blue-400 font-medium mb-6" data-id="element-58">
                  Tu Mini-Taller en Casa en 15 Minutos
                </p>

                <p className="text-zinc-300 mb-6 font-medium" data-id="element-59">
                  Las 7 herramientas exactas que cubren el 80% de las
                  reparaciones sin gastar de más.
                </p>

                <ul className="space-y-4 text-zinc-400" data-id="element-60">
                  <li className="flex items-start gap-3" data-id="element-61">
                    <span className="text-blue-500 mt-1" data-id="element-62">✓</span>
                    <span data-id="element-63">
                      Cómo elegir cada una sin equivocarte en la ferretería.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-64">
                    <span className="text-blue-500 mt-1" data-id="element-65">✓</span>
                    <span data-id="element-66">
                      El setup del mini-taller en casa para no perder tornillos
                      ni tiempo.
                    </span>
                  </li>
                  <li className="flex items-start gap-3" data-id="element-67">
                    <span className="text-blue-500 mt-1" data-id="element-68">✓</span>
                    <span data-id="element-69">
                      Los checklists imprimibles para comprar y preparar todo
                      rápido.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}